/* eslint-disable max-len */
import React, { useRef ,useEffect,useState, useContext} from "react"
import { GetBranchId } from "../../../../../../CommonMethods/GetBranchId";
import { dataService } from "../../../../../../services/data.services";
import moment from "moment";
import { addRow } from "../../StudentAttendanceSlice";
import { useDispatch } from "react-redux"; 
import GlobalContext from "../../../../../../components/Context/GloablContext";

export default function SearchBar({
    attendanceRecords,
    setAttendanceRecords,
    handleFetchStudentAttendance,
    selectedDate,
    params,
    setLoading,
    type
}){
    const inputRef=useRef()
    const dispatch=useDispatch()
    const {setToastErrorMessage} = useContext(GlobalContext)
    const [selectedSearch,setSelectedSearch]=useState('')
    const [studentDropdownData,setStudentDropdownData]=useState([])
    let copyParams={...params}
    delete copyParams.start_date
    delete copyParams.end_date
    delete copyParams.page_number
    delete copyParams.limit
    if(type === "staff") {
        delete copyParams.fy_status
        if(copyParams.employee_type === ''){
            delete copyParams.employee_type
        }
    }
    copyParams.search?delete copyParams.search:""
    const queryParameters = Object.entries(copyParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
    
    useEffect(()=>{
        const timer=setTimeout(async ()=>{
            if(selectedSearch?.length>=3&&selectedSearch===inputRef.current.value)
            {   
                // let copy = copyParams.delete("fy_status")
                // const branch_id = await GetBranchId()
                try{
                    const branch_id = await GetBranchId()
                    const res = await dataService.GetAPI(`${type === "staff" ? "staff-attendance" : "student-attendance"}?branch_id=${branch_id}&${queryParameters}&date=${moment(selectedDate).format("YYYY-MM-DD")}&search=${encodeURIComponent(selectedSearch)}`);
                    let filteredObjectsToAdd
                    if(type === "staff" ){
                        filteredObjectsToAdd = res?.data?.data?.filter((newObj) => {
                            return !attendanceRecords.some((existingObj) => (type === "staff" ? existingObj.staff_id === newObj.staff_id : existingObj.student_id === newObj.student_id));
                        });
                    } else{
                        filteredObjectsToAdd = res?.data?.data?.data?.filter((newObj) => {
                            return !attendanceRecords.some((existingObj) => (type === "staff" ? existingObj.staff_id === newObj.staff_id : existingObj.student_id === newObj.student_id));
                        });
                    }
                    setStudentDropdownData(filteredObjectsToAdd)
                }catch(error){
                    if(error?.response?.data?.message  !== 'No records found'){
                        console.log("error", error)
                        setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
                    }
                }
            }
        },500)
        return()=>{
            clearTimeout(timer)
        }
    },[selectedSearch,inputRef])

    const handleSearchStudentAdd=async(selectedId)=>{
        setLoading(true)
        const studentIdList=attendanceRecords?.map((obj)=>(type === "staff" ? obj.staff_id : obj.student_id))
        studentIdList.push(selectedId)
        try{
            const branch_id = await GetBranchId()
            const response=await dataService.GetAPI(`${type === "staff" ? "staff-attendance" : "student-attendance"}?branch_id=${branch_id}&${queryParameters}&${type === "staff" ? "employee_ids=" : "student_ids="}${studentIdList}&date=${selectedDate}`)
            if (response.data.status === 200) {
                setLoading(false)
                setAttendanceRecords(response.data.data.data)
                dispatch(addRow(selectedId))
            }
        }catch(error){
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");

        }
        setStudentDropdownData([])
        setSelectedSearch('')
    }

    return(
        <div class="relative ml-2.5">
            <label for="input"></label>
            <input 
                type="text" 
                class="w-[260px] slct-inpt-fld search_student" 
                style={{'width':'275px','padding-right':'35px'}}
                placeholder={`Search ${type === "staff" ? "Employee" : "Student"} by Name / ID`} ref={inputRef}
                onChange={event=>setSelectedSearch(event.target.value)}
                value={selectedSearch} />
            <button class="absolute top-[50%] -translate-y-[50%] right-2">
                <img loading="lazy" decoding="async" src="/images/search.svg" alt="img" />
            </button>
            {selectedSearch?.length>0&&studentDropdownData?.length>0 && <ul class=" slct_drp_dwn min-w-full [&[data-te-dropdown-show]]:block select_student z-[2]" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                <li class="max-h-[150px] overflow-auto scroll-bar" >
                    {studentDropdownData?.map((student)=>(
                        <ul key={type === "staff" ? student.staff_id : student.student_id}>
                            <li>
                                <p onClick={()=>handleSearchStudentAdd(type === "staff" ? student.staff_id : student.student_id)} title={type === "staff" ? student?.full_name+'('+student.employee_number+')' : student?.student_name+'('+student?.student_id+')'} class="slct_drp_dwn_optn selected_Class" href="#" data-te-dropdown-item-ref>{type === "staff" ? student?.full_name+'('+student.employee_number+')' : student?.student_name+'('+student?.student_id+')'}
                                </p>
                            </li>
                         
                        </ul>
                    ))
                    
                    } 
                </li>
            </ul>}
        </div>
    )
}